import { tv } from '../tv';

export const breadcrumbItemVariants = tv({
  // explicit text color (not inherited from the list): legacy global anchor
  // styles would otherwise repaint the link — drop once those styles die
  base: `flex items-center gap-2 rounded-sm text-zinc-300 no-underline transition-colors duration-150
    motion-reduce:transition-none
    focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-50`,
  variants: {
    interactive: {
      true: 'cursor-pointer hover:text-zinc-100',
      false: '',
    },
  },
  defaultVariants: {
    interactive: false,
  },
});
